import { HTTPError } from "./HTTPError";

export class BadRequestError extends HTTPError {}
